import { memo } from 'react';

import { PowerCallFlowExtraDataT } from '../PowerCallFlow';
import type {
  FlowCallNodeAudioMessage,
  FlowCallNodeCallback,
  FlowCallNodeIVR,
  FlowCallNodeRecordConversation,
  FlowCallNodeVoicemail,
} from '../nodeTypes';
import type { AnnouncementT } from '../types';

const AnnounceFromPayload = ({
  node,
  extraData,
  text,
}: {
  node:
    | FlowCallNodeAudioMessage
    | FlowCallNodeCallback
    | FlowCallNodeRecordConversation
    | FlowCallNodeIVR
    | FlowCallNodeVoicemail;
  extraData: PowerCallFlowExtraDataT;
  text?: string;
}) => {
  const { payload: { announcement } = { announcement: null } } = node;

  let label = 'None';
  let url = '';

  if (announcement?.file) {
    label = announcement.file.label;
    url = announcement.file.url;
  }

  if (!label && url) {
    if (extraData.announcements) {
      const xAnnouncement = extraData.announcements.find(
        (ann: AnnouncementT) => ann.url === url,
      );
      if (xAnnouncement && xAnnouncement.pretty_name) {
        label = xAnnouncement.pretty_name;
      }
    }
  }

  if (!label) {
    label = /([^/]+$)/.exec(url)?.toString() || 'None';
  }

  const nodeText = text || 'Announcement';

  return (
    <div
      style={{
        height: '16px',
        maxWidth: '100%',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      }}
    >
      {nodeText} <strong>{label}</strong>
    </div>
  );
};

export default memo(AnnounceFromPayload);
